const initialState = {
  fetching: false,
};

const reports = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_REPORT':
      return {
        ...state,
        fetching: true,
      };

    case 'GET_REPORT_SUCCESS':
    case 'GET_REPORT_FAILURE':
      return {
        ...state,
        fetching: false,
      };

    default:
      return state;
  }
};

export default reports;

export const isFetching = (state) => state.fetching;
